// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/employee/actionCreator";
import * as employeeSelectors from "@modules/employee/selectors";
import { Button, SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import type { StepProps } from "@components";
import type { State } from "@store/reducers";
import { split } from "@transformers/schema";
import type { ExclusionReasonDetails } from "@modules/employee/reducer/personal-details/types";

type PropsFromState = $Exact<{
  schema: Object | null,
  alertExclusionAlertsOptions: Array<Object>,
  exclusionReasonDetails: ExclusionReasonDetails,
}>;

type PropsFromDispatch = $Exact<{
  setExclusionReasonDetails: typeof actionCreators.SetExclusionReasonDetails,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step2ReasonForAlertExclusion extends React.Component<Props> {
  exclusionReasonSchema = split(this.props.schema, ["exclusionReason", "activeFrom", "activeTo"]);

  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  handleNextStep = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    this.props.setExclusionReasonDetails(formData);
    if (this.props.handleSubmit) {
      this.props.handleSubmit(formData, true);
    }
  };

  get data(): ExclusionReasonDetails {
    return {
      ...this.props.exclusionReasonDetails,
    };
  }

  //modifying the original schema with adding options to exclusionReason
  //taken from request after step 1, where alert is selcted
  getSchema = (options: Array<Object>) => {
    this.exclusionReasonSchema.properties.exclusionReason.properties.id.oneOf = options;
    return this.exclusionReasonSchema;
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            {(this.props.alertExclusionAlertsOptions.length && (
              <SchemaForm
                ref={this.formRef}
                className="w-100"
                formData={this.data}
                schema={this.getSchema(this.props.alertExclusionAlertsOptions)}
                uiSchema={uiSchema(this.props.t)}
                onSubmit={this.handleSubmit}
                externalSubmit
              >
                <div className="d-flex justify-content-center" />
              </SchemaForm>
            )) ||
              ""}
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button onClick={this.handleNextStep}>
            {this.props.t("ADD_EXLUSION_ALERT_STEP_2_NEXT_BUTTON")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    schema: employeeSelectors.getEmployeeAlertExclusionSchema(state),
    alertExclusionAlertsOptions: employeeSelectors.getAlertExclusionAlertsOptions(state),
    exclusionReasonDetails: employeeSelectors.getExclusionReasonDetails(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setExclusionReasonDetails: actionCreators.SetExclusionReasonDetails,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step2ReasonForAlertExclusion);
